import React, {useContext, useEffect, useState} from "react";
import axios from "axios";
import {FaEdit, FaTrash} from "react-icons/fa";
import toast from "bootstrap/js/src/toast";
import {ToastContext} from "../App";

export default function Programs() {
    const [programs, setPrograms] = useState([]);
    const [exercises, setExercises] = useState([]);
    const [muscleGroups, setMuscleGroups] = useState([]);
    const showToast = useContext(ToastContext);
    const [form, setForm] = useState({
        name: "",
        description: "",
        type: "",
        days: [{day_number: "", exercise_ids: []}]
    });
    const [editingId, setEditingId] = useState(null);

    useEffect(() => {
        fetchPrograms();
        fetchExercises();
        fetchMuscleGroups();
    }, []);

    const fetchPrograms = async () => {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/programs`);
        setPrograms(res.data);
    };

    const fetchExercises = async () => {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/exercises`);
        setExercises(res.data);
    };

    const fetchMuscleGroups = async () => {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/muscle-groups`);
        setMuscleGroups(res.data);
    };

    const handleSubmit = async () => {
        if (!form.name || !form.type) return showToast("يرجى تعبئة الحقول المطلوبة", "danger");
        if (editingId) {
            await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/programs/${editingId}`, form);
        } else {
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/programs`, form);
        }
        setForm({name: "", description: "", type: "", days: [{day_number: "", exercise_ids: []}]});
        setEditingId(null);
        fetchPrograms();
    };

    const handleEdit = (program) => {
        setForm({
            name: program.name,
            description: program.description,
            type: program.type,
            days: program.days.map((d) => ({
                day_number: d.day_number,
                exercise_ids: d.exercises?.map((ex) => ex.id) || [],
                notes: d.notes || ""
            }))
        });
        setEditingId(program.id);
    };

    const handleDelete = async (id) => {
        if (!window.confirm("هل أنت متأكد من حذف البرنامج؟")) return;
        await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/programs/${id}`);
        fetchPrograms();
    };

    const toggleExercise = (dayIndex, exId) => {
        setForm((prev) => {
            const days = [...prev.days];
            const day = days[dayIndex];
            day.exercise_ids = day.exercise_ids.includes(exId)
                ? day.exercise_ids.filter((id) => id !== exId)
                : [...day.exercise_ids, exId];
            return {...prev, days};
        });
    };

    const addDay = () => {
        setForm((prev) => ({
            ...prev,
            days: [...prev.days, {day_number: "", exercise_ids: []}]
        }));
    };

    return (
        <div className={"content"}>

            <div className="container" dir="rtl">
                <h2 className="mb-4 mt-5">إدارة البرامج</h2>

                <div className="card p-3 mb-4">
                    <div className="row mb-3">
                        <div className="col-md-6 col-sm-12">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="اسم البرنامج"
                                value={form.name}
                                onChange={(e) => setForm({...form, name: e.target.value})}
                            />
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <select
                                className="form-select"
                                value={form.type}
                                onChange={(e) => setForm({...form, type: e.target.value})}
                            >
                                <option value="">اختر نوع البرنامج</option>
                                <option value="تمارين">برنامج تمارين</option>
                                <option value="غذاء">برنامج غذائي</option>
                            </select>
                        </div>
                    </div>

                    <div className="mb-3">
                    <textarea
                        className="form-control"
                        placeholder="الوصف"
                        rows="3"
                        value={form.description}
                        onChange={(e) => setForm({...form, description: e.target.value})}
                    ></textarea>
                    </div>


                    {/* الأيام والتمارين */}
                    {form.type === "تمارين" &&
                        form.days.map((day, dayIndex) => (
                            <div key={dayIndex} className="mb-3 p-2 border rounded">
                                <div className="d-flex justify-content-between align-items-center">
                                    <input
                                        type="text"
                                        className="form-control w-50"
                                        placeholder=""
                                        value={day.day_number}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setForm(prev => {
                                                const days = [...prev.days];
                                                days[dayIndex] = {...days[dayIndex], day_number: value};
                                                return {...prev, days};
                                            });
                                        }}
                                    />

                                    {form.days.length > 1 && (
                                        <button
                                            className="btn btn-sm btn-danger"
                                            onClick={() =>
                                                setForm((prev) => ({
                                                    ...prev,
                                                    days: prev.days.filter((_, i) => i !== dayIndex)
                                                }))
                                            }
                                        >
                                            حذف اليوم
                                        </button>
                                    )}
                                </div>

                                {muscleGroups.map((group) => (
                                    <div key={group.id} className="mb-2">
                                        <h6 className="text-primary">{group.name}</h6>
                                        {exercises
                                            .filter((ex) => ex.muscle_group_id === group.id)
                                            .map((ex) => {
                                                const isChecked = day.exercise_ids.includes(ex.id);
                                                return (
                                                    <div
                                                        key={ex.id}
                                                        className="form-check d-flex align-items-center mb-1"
                                                        style={{gap: "8px"}}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input mx-2"
                                                            checked={isChecked}
                                                            onChange={() => {
                                                                setForm((prev) => ({
                                                                    ...prev,
                                                                    days: prev.days.map((d, idx) => {
                                                                        if (idx !== dayIndex) return d;
                                                                        const updatedIds = isChecked
                                                                            ? d.exercise_ids.filter((id) => id !== ex.id)
                                                                            : [...d.exercise_ids, ex.id];
                                                                        return {...d, exercise_ids: updatedIds};
                                                                    })
                                                                }));
                                                            }}
                                                            id={`day${dayIndex}-ex${ex.id}`}
                                                        />
                                                        <label className="form-check-label mb-0"
                                                               htmlFor={`day${dayIndex}-ex${ex.id}`}>
                                                            {ex.name} ({ex.target_reps} عدات)
                                                        </label>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                ))}
                            </div>
                        ))}

                    {form.type === "غذاء" &&
                        form.days.map((day, dayIndex) => (
                            <div key={dayIndex} className="mb-3 p-2 border rounded">
                                <div className="d-flex justify-content-between align-items-center">
                                    <input
                                        type="text"
                                        className="form-control w-50"
                                        placeholder="اسم اليوم (مثال: تمارين الصدر"
                                        value={day.day_number}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setForm(prev => {
                                                const days = [...prev.days];
                                                days[dayIndex] = {...days[dayIndex], day_number: value};
                                                return {...prev, days};
                                            });
                                        }}
                                    />

                                    {form.days.length > 1 && (
                                        <button
                                            className="btn btn-sm btn-danger"
                                            onClick={() =>
                                                setForm((prev) => ({
                                                    ...prev,
                                                    days: prev.days.filter((_, i) => i !== dayIndex)
                                                }))
                                            }
                                        >
                                            حذف اليوم
                                        </button>
                                    )}
                                </div>

                                <textarea
                                    className="form-control mt-2"
                                    placeholder="أدخل ملاحظات الطعام لليوم"
                                    value={day.notes || ""}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setForm((prev) => {
                                            const days = [...prev.days];
                                            days[dayIndex] = {...days[dayIndex], notes: value};
                                            return {...prev, days};
                                        });
                                    }}
                                    rows={4}
                                />
                            </div>
                        ))}


                    <button
                        className="btn btn-secondary mb-2"
                        onClick={() => {
                            setForm((prev) => ({
                                ...prev,
                                days: [...prev.days, {day_number: "", exercise_ids: []}]
                            }));
                        }}
                    >
                        إضافة يوم
                    </button>

                    <button className="btn btn-success" onClick={handleSubmit}>
                        {editingId ? "تحديث البرنامج" : "إضافة البرنامج"}
                    </button>
                </div>

                <h3 className="mb-3">البرامج الموجودة</h3>

                <div
                    className="card shadow-sm border-0"
                    style={{
                        maxHeight: "600px",
                        overflowY: "auto",
                        borderRadius: "12px",
                        fontSize: "18px"
                    }}
                >
                    <table className="table table-hover table-striped align-middle text-center mb-0">
                        <thead className="table-dark sticky-top">
                        <tr>
                            <th>#</th>
                            <th>اسم البرنامج</th>
                            <th>النوع</th>
                            <th>إجراءات</th>
                        </tr>
                        </thead>
                        <tbody>
                        {programs.length > 0 ? (
                            programs.map((p, i) => (
                                <tr key={p.id}>
                                    <td>{i + 1}</td>
                                    <td>{p.name}</td>
                                    <td>
              <span

              >
                {p.type}
              </span>
                                    </td>
                                    <td>
                                        <FaEdit
                                            style={{cursor: "pointer", color: "blue", marginRight: "10px"}}
                                            size={18}
                                            title="تعديل"
                                            onClick={() => handleEdit(p)}
                                        />
                                        <FaTrash
                                            style={{cursor: "pointer", color: "red", marginRight: "10px"}}
                                            size={18}
                                            title="حذف"
                                            onClick={() => handleDelete(p.id)}
                                        />
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-muted">
                                    لا يوجد برامج حالياً
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
